module.exports = __webpack_public_path__ + "a6da74ce11816c7513ae67320d05d817.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/sparkasse.png
// module id = 945
// module chunks = 0